import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import ShopApplyForm from "@/pages/checkout/shop-apply/shopApplyForm/ShopApplyForm";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import { CDN_LINK } from "@globalConfig";
import stl from "./ShopApply.module.css";
import { useTranslation } from "@i18n";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import CancelButton from "../../../components/UiKit/Buttons/CancelButton/CancelButton";
import MobileHeaderwithCancleFunction from "@/_LayoutsRelated/mobileHeaders/mobileHeaderwithCancleFunction/MobileHeaderwithCancleFunction";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useLocalStorage from "@hooks/useLocalStorage";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import Loader from "@componentsShared/Loader/Loader";
import { normalizeIdNumber } from "@/utils/stringHelpers";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
var ShopApply = function ShopApply() {
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useState = useState(false),
    showOtp = _useState[0],
    setShowOtp = _useState[1];
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    formData = _useCheckoutOrder$sta.formData,
    fetch_loading = _useCheckoutOrder$sta.fetch_loading;
  var post_id = useCheckoutOrder().queryParams.post_id;
  var setFormItem = useCheckoutOrder().actions.setFormItem;
  var fetch__getOrderWithPaymentInfo = useCheckoutOrder().remote_actions.fetch__getOrderWithPaymentInfo;
  var grantedPopup = useBoolean();
  useEffect(function () {
    if (!(formData !== null && formData !== void 0 && formData.city_id) && checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.city_id) {
      setFormItem("city_id", checkoutOrder.city_id);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.city_id]);
  useEffect(function () {
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.id) {
      fetch__getOrderWithPaymentInfo(post_id, checkoutOrder.id);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id]);
  var verifyOtpCb = function verifyOtpCb(userData) {
    var _useLocalStorage = useLocalStorage(),
      setLocalStorage = _useLocalStorage.setLocalStorage;
    setLocalStorage("otp_visited_".concat(checkoutOrder.id), "1");
    if (!isLoggedIn) {
      handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: formData.phone_number,
        lang: lang,
        referral_location: "cash_order"
      });
    }
    navigateTo("/checkout/create-araboon?post_id=".concat(post_id, "&order_id=").concat(checkoutOrder.id));
  };
  var main_render = function main_render() {
    if (showOtp) {
      return /*#__PURE__*/React.createElement(OtpVerification, {
        FIX_ME__extra_params: {
          order_id: normalizeIdNumber(checkoutOrder.id)
        },
        source: "cash_order_verify",
        after_verify_callback: verifyOtpCb,
        scenario: "signup",
        phone_number: formData.phone_number,
        onEditNumber: function onEditNumber() {
          setShowOtp(false);
        },
        design: {
          btnText: t("تحقق من الرمز", {
            ns: "web_sell_trade"
          }),
          className: stl.otpWrapper,
          subClassName: stl.fontSize,
          label: t("ادخل رمز التحقق لتقديم الطلب", {
            ns: "web_sell_trade"
          }),
          otpBtn: stl.otpBtn
        }
      });
    }
    return /*#__PURE__*/React.createElement(ShopApplyForm, {
      loading: fetch_loading,
      setShowOtp: setShowOtp,
      onClickInfoIcon: grantedPopup.setTrue
    });
  };
  return /*#__PURE__*/React.createElement(Layout, {
    disableLoader: true,
    loading: fetch_loading,
    authenticationMsg: true,
    mainClass: "CheckOut",
    logoNotClickable: true,
    headHideLinks: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeaderwithCancleFunction, {
      title: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_title,
      buttonFunction: function buttonFunction() {
        if (showOtp) {
          setShowOtp(false);
          return;
        }
        // fixme, not working, is it still needed?
        navigateTo("/cardetail/".concat(post_id));
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CancelButton, {
    onClick: function onClick() {
      if (showOtp) if (showOtp) {
        setShowOtp(false);
        return;
      }
      navigateTo("/cardetail/".concat(post_id));
    },
    className: "".concat(stl.CancelButton, " m-hide")
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement(HeadingSteps, null, /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "completed" : "active"
  }, t("أضف معلوماتك", {
    ns: "web_checkout_cash"
  })), !isLoggedIn && /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "active" : ""
  }, t("التحقق من الرمز", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("span", null, t("الدفع", {
    ns: "web_checkout_cash"
  }))), main_render())), /*#__PURE__*/React.createElement("div", {
    className: "m-hide"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.stickyContainer
  }, isDesktop && /*#__PURE__*/React.createElement(PaymentInfo, {
    loading: !checkoutOrder,
    checkoutOrder: checkoutOrder,
    className: stl.desktopCarInfo,
    onClickInfoIcon: grantedPopup.setTrue
  }), checkoutOrder && checkoutOrder.post_is_new != 1 && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.is_warranty_10_day) && /*#__PURE__*/React.createElement(NDayGuarantee, {
    img: CDN_LINK + "/assets/images/dm10.svg"
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
  }, t("تكلفة الشحن", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("سيتم تحديد تكلفة الشحن من خلال مندوب المبيعات بعد تأكيد الحجز", {
    ns: "web_checkout_cash"
  }))))));
};
export default ShopApply;